import React from 'react';
import PropTypes from 'prop-types';
import shortid from 'shortid';
import styled from 'styled-components';

import { matchMedia } from 'dom-utils';
import { MOBILE_LANDSCAPE_MEDIA } from 'style/constants';
import { BACKGROUND_ACTIVE, TITLE_FONT } from 'style/mixins';
import { withEndUserT, DynamicTranslationType } from 'hooks/use-translation';

const ClickableContainer = styled.div`
  cursor: pointer;
`;

const FlexWrapper = styled.div`
  ${BACKGROUND_ACTIVE}
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 5px;
  ${TITLE_FONT}
  font-size: 18px;
  font-weight: 700;
  text-transform: uppercase;
`;

class ShowPanelOverlayCta extends React.Component {
  static propTypes = {
    children: PropTypes.node,
    ctaRenderer: PropTypes.shape({
      panelId: PropTypes.string,
      text: PropTypes.string,
    }).isRequired,
    endUserT: PropTypes.func.isRequired,
    isLandscape: PropTypes.bool.isRequired,
    isMobileLayout: PropTypes.bool.isRequired,
    onAddMessageOverlay: PropTypes.func.isRequired,
    onEngagedOverlay: PropTypes.func.isRequired,
    onOpenPanel: PropTypes.func.isRequired,
    overlayId: PropTypes.string.isRequired,
    testId: PropTypes.string,
  };

  static defaultProps = {
    children: undefined,
    testId: undefined,
  };

  onOpenPanelClick = () => {
    const {
      ctaRenderer: { panelId },
      endUserT,
      isLandscape,
      isMobileLayout,
      onEngagedOverlay,
      onOpenPanel,
      onAddMessageOverlay,
    } = this.props;

    onEngagedOverlay();

    if (panelId) {
      onOpenPanel({ id: panelId });

      if (isMobileLayout && isLandscape && matchMedia(MOBILE_LANDSCAPE_MEDIA).matches) {
        const message = endUserT(
          [DynamicTranslationType.overlayRotatePhone],
          ['ADMIN_OVERLAYS_ROTATE_YOUR_PHONE'],
        );
        const overlayPayload = {
          key: shortid.generate(),
          payload: {
            data: {
              duration: 15,
              kind: 'message',
              message,
              trackName: 'Message: Please rotate your phone',
            },
            removeOnPortrait: true,
          },
        };

        onAddMessageOverlay(overlayPayload);
      }
    }
  };

  render() {
    const { children, ctaRenderer: { text }, endUserT, overlayId, testId } = this.props;

    return (
      <ClickableContainer data-testid={testId} onClick={this.onOpenPanelClick}>
        {
          children || (
            <FlexWrapper>
              {
                endUserT([
                  DynamicTranslationType.overlayCtaText,
                  { overlayId },
                ]) || text
              }
            </FlexWrapper>
          )
        }
      </ClickableContainer>
    );
  }
}

export default withEndUserT(ShowPanelOverlayCta);
